export class FloorModel {
    id: string = "";
    name: string = "";
    tempName?: string;
    buildingId?: string;
}

export function floorModelFactory(json?: any): FloorModel {
  json = json || {};
  return {
    id: json.id,
    name: json.name || "",
    tempName: "",
    buildingId: json.buildingId || "",
    enableEdit: false,
  } as FloorModel;
}

export function floorModelListFactory(json?: any) {
  return Array.from(json || []).map(floor => floorModelFactory(floor));
}
